import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectors, verifiers } from '@yola/subscription-manager-js';
import useFeatureFlags from 'src/js/modules/feature-flags/hooks/use-feature-flags';

const useActiveUserSubscriptions = () => {
  const currentPackage = useSelector(selectors.getCurrentPackage, shallowEqual);
  const trial = useSelector(selectors.getCurrentPackageTrialStatus);
  const currentEcommercePlan = useSelector(selectors.getCurrentEcommercePlan, shallowEqual);
  const activeHostingSubscription = useSelector(
    selectors.getActiveHostingSubscription,
    shallowEqual
  );
  const activeEcommerceSubscription = useSelector(
    selectors.getActiveEcommerceSubscription,
    shallowEqual
  );
  const [featureFlags] = useFeatureFlags(['free_trial_upsell']);
  const { free_trial_upsell: isFreeTrialUpsellEnabled } = featureFlags;

  return useMemo(() => {
    const userSubscriptions = [];

    if (activeHostingSubscription) {
      userSubscriptions.push({
        name: currentPackage.name,
        subscriptionMeta: activeHostingSubscription,
        isEcommerce: false,
        ...(isFreeTrialUpsellEnabled && { trial }),
      });
    }

    if (
      activeEcommerceSubscription &&
      !verifiers.isFreeEcommercePlanType(activeEcommerceSubscription.type)
    ) {
      userSubscriptions.push({
        name: currentEcommercePlan.name,
        subscriptionMeta: activeEcommerceSubscription,
        isEcommerce: true,
      });
    }

    return userSubscriptions;
  }, [
    activeEcommerceSubscription,
    activeHostingSubscription,
    currentEcommercePlan,
    currentPackage,
    isFreeTrialUpsellEnabled,
    trial,
  ]);
};

export default useActiveUserSubscriptions;
